<template>
  <ApplicationBase
    v-bind="vBindBase"
    color="blue"
    applicationType="owner-occupancy"
    v-on="vOnBase"
    class="application-owner-occupancy"
  >
    <template #apartments>
      <ApplicationApartments
        v-bind="vBindApartments"
        color="blue"
        v-on="vOnApartments"
        apartmentTypeSearchQueryValue="owner-occupancy"
      />
    </template>

    <div class="container container--narrow">

      <div class="application-section-bg">
        <ApplicationApplicants
          v-bind="vBindApplicants"
          applicationType="owner-occupancy"
          @update="applicants = $event"
        />
      </div>
    </div>

    <ApplicationDivider wrapper-classes="container"/>

    <input type="hidden" name="Checksum" :value=form.Checksum />
  </ApplicationBase>
</template>

<script>
  import {integer} from 'vuelidate/lib/validators';
  import {sprintf} from 'sprintf-js';

  import {validations} from '../lib/applicationSharedOnlyOwnerOccupancy';
  import application from './mixins/application';
  import LoadSpinner from './components/LoadSpinner';
  import globals from '../lib/globals';

  import { municipalities } from '../helpers/municipalities'

  export default {
    components: {
      LoadSpinner,
    },
    mixins: [
      application({
        favouritesType: 'owner-occupancy',
        presetMapExtend: {
          //
        },
        localSaveExtend: {
          localSaveFromState(state) {
            return {
              shareOrderNumber: state.shareOrderNumber,
              orderNumbers: state.orderNumbers,
            };
          },
          stateFromLocalSave(state, localSave) {
            state.shareOrderNumber = localSave.shareOrderNumber;
            state.orderNumbers = localSave.orderNumbers;
          },
        },
        applyOtherData: {
          conditionFavouritesType: 'right-of-occupancy',
          title: 'Korissasi on myös ASO-asuntoja',
          ctaText: 'Jätä ASO-asuntohakemus',
          ctaUrl: globals.urlApplicationRightOfOccupancy,
          color: 'pink',
        },
      }),
    ],
    props: {
      textOrderNumberAfter: {
        type: String,
        default: '',
      },
      textOrderNumberBefore: {
        type: String,
        default: '',
      },
      warningOrderNumberBefore: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        shareOrderNumber: false,
        orderNumbers: {},
        form: {
          Type: '3',
        },
        municipalities,
      };
    },
    computed: {
      cities() {
        const objectCities = Object.assign({}, ...this.apartments
          .map(apartment => ({[apartment.city.mpc_kuntaid]: apartment.city.mpc_name})));
        return Object.entries(objectCities).map(([uuid, label]) => ({uuid, label}));
      },
    },
    validations() {
      const validationsOrderNumber = {
        integer
      };

      return {
        orderNumbers: Object.assign({}, ...Object
          .entries(this.orderNumbers)
          .map(([key]) => ({[key]: validationsOrderNumber}))
        ),
        applicants: {
          $each: {
            ...validations.applicant,
          },
        },
        form: {
          ...validations.form
        }
      };
    },
    watch: {
      cities() {
        // Whenever cities are added, orderNumbers must be updated with new properties.
        this.orderNumbers = {
          ...Object.assign({}, ...this.cities.map(city => ({[city.uuid]: ''}))),
          ...this.orderNumbers,
        };
      },
    },
    methods: {
      sprintf,

      checkTime: function() {
        // Are we past the time (29.12.2023 10:00:00) when we should hide kuntakohtainen aso-ordernumber?
        if (Date.now() >= 1703836800000) {
          this.form.isARA = true;
          return false;
        } else {
          return true;
        }
      },

      resolveASOOrderNumberRequired(city, index, numberOfGroupedLocalitiesByCity) {
        let isRequired = false;
        // If ARA-number is not selected isRequired=true by default
        if (!this.form.isARA) {
          isRequired = true;
        } else {
          // ARA-number has been selected -> city order number is not required
          return false;
        }
        // If there are more than one city
        if (Object.keys(numberOfGroupedLocalitiesByCity).length > 1) {
          // If the ASO number is shared
          if (this.shareOrderNumber) {
            // Only first number is required
            if (index > 0) {
              isRequired = false;
            } else {
              isRequired = true;
            }
          } else {
            // Are there multiple localities in the current city
            if (numberOfGroupedLocalitiesByCity[city.uuid] && numberOfGroupedLocalitiesByCity[city.uuid].length > 1) {
              isRequired = true;
            // Only one locality
            } else {
              // Are we resident in the locality
              if (numberOfGroupedLocalitiesByCity[city.uuid] && this.residentInLocation.localityId === numberOfGroupedLocalitiesByCity[city.uuid][0]) {
                isRequired = false;
              } else {
                isRequired = true;
              }
            }
          }
        // Only one city
        } else {
          // If there are more than one locality in the city
          if (numberOfGroupedLocalitiesByCity[city.uuid] && numberOfGroupedLocalitiesByCity[city.uuid].length > 1) {
            isRequired = true;
          // Only one locality
          } else {
            // Check if isResident in the locality
            if (numberOfGroupedLocalitiesByCity[city.uuid] && this.residentInLocation.localityId === numberOfGroupedLocalitiesByCity[city.uuid][0]) {
              isRequired = false;
            } else {
              isRequired = true;
            }
          }
        }
        return isRequired;
      },

      createFormApartment(apartment) {
        return {
          Id: apartment.mpc_asuntoid,
          Resident: apartment.mpc_kohdeid === this.residentInLocation.localityId ? 'true' : 'false',
          CampaignCode: apartment.ava_kampanjakoodi,
        };
      },

      isExisting() {
        return (
          this.isExistingApplication
        )
      },
    },
  }
</script>

<style lang="scss">
  @import '~styles/definitions';

  .application-right-of-occupancy {
  }

  .application-right-of-occupancy__order-number-row {
    margin-bottom: r(32);
  }

  .application-right-of-occupancy__share-checkbox {
    margin-top: r(4);
  }

  .text-ordernumber-before {
    margin-bottom: r(32);
  }

  .order-number-radio-group {
    display: flex;
    flex-direction: column;

    label {
      margin: r(4) 0 0;

      span {
        margin-left: r(4);
      }
    }
  }
</style>
